import { getDecisioningStudioWizardAllowed } from "./getDecisioningStudioWizardAllowed";
import type { DecisioningStudioAgentEditUrlAllowedProps, DecisioningStudioWizardAllowedArgs } from "./types";

/**
 * Who may open the edit URL: the wizard's audience and, with self-serve action banks on, action bank
 * editors. Action bank viewers also get in for a Pro agent, whose editor opens read-only, or when the
 * agent is unknown, as on the route; the page turns away the rest. Editors don't need the view
 * permission, since the permissions read here don't add the one editing implies.
 */
export const getDecisioningStudioAgentEditUrlAllowed = (
  { featureOn, hasPermission, isImpersonating }: DecisioningStudioWizardAllowedArgs,
  { isProAgent }: DecisioningStudioAgentEditUrlAllowedProps = {}
): boolean => {
  if (getDecisioningStudioWizardAllowed({ featureOn, hasPermission, isImpersonating })) {
    return true;
  }

  if (!featureOn("decisioning_studio_self_serve_action_banks")) {
    return false;
  }

  const canEditActionBanks = hasPermission("appGroup", { permission: "editDecisioningStudioActionBanks" });
  if (isProAgent === false) {
    return canEditActionBanks;
  }

  return canEditActionBanks || hasPermission("appGroup", { permission: "viewDecisioningStudioActionBanks" });
};
